export function Loader({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10">
      <div className="relative w-10 h-10">
        <div className="absolute inset-0 rounded-full border-2 border-line" />
        <div className="absolute inset-0 rounded-full border-2 border-emerald-glow border-t-transparent animate-spin" />
      </div>
      <span className="text-sm text-ink-muted">{label}</span>
    </div>
  );
}
